const not_authenticated_es = require('./not_authenticated.json')
export default not_authenticated_es